import auth from '@/middleware/modules/auth'
import hasPublisher from '@/middleware/modules/hasPublisher'
import { checkAppLimits } from '@/middleware/modules/campaigns'
import { checkAccessActionSB } from '@/middleware/modules/sb-campaign'
import SocialProductsIndex from '@/views/social-products/SocialProductsIndex'
import SocialBoostIndex from '@/views/social-products/social-boost/SocialBoostIndex'
import SocialBoostList from '@/views/social-products/social-boost/SocialBoostList'
import CreateCampaign from '@/views/social-products/social-boost/forms/CreateCampaign.vue'
import EditCampaign from '@/views/social-products/social-boost/forms/EditCampaign.vue'
import CreateFlight from '@/views/social-products/social-boost/forms/CreateFlight.vue'
import EditFlight from '@/views/social-products/social-boost/forms/EditFlight.vue'
import CreateAssets from '@/views/social-products/social-boost/forms/CreateAssets.vue'
import EditAsset from '@/views/social-products/social-boost/forms/EditAsset.vue'

import ViewCampaignFlight from '@/views/social-products/social-boost/flights/ViewCampaignFlight.vue'
import ViewFlight from '@/views/social-products/social-boost/flights/ViewFlight.vue'
// Flights TABs
import AssetsTabs from '@/views/social-products/social-boost/flights/tabs/Assets.vue'
import CreativesTabs from '@/views/social-products/social-boost/flights/tabs/Creatives.vue'
import ScreenshotsTabs from '@/views/social-products/social-boost/flights/tabs/Screenshots.vue'
import AnalyticsTabs from '@/views/social-products/social-boost/flights/tabs/Analytics.vue'
import ReportsTabs from '@/views/social-products/social-boost/flights/tabs/Reports.vue'
import ActivityTabs from '@/views/social-products/social-boost/flights/tabs/Activity.vue'
import NotesTabs from '@/views/social-products/social-boost/flights/tabs/Notes.vue'

//Campaigns
import ViewCampaign from '@/views/social-products/social-boost/campaign/ViewCampaign.vue'
//Campaign Tabs
import FlightsTab from '@/views/social-products/social-boost/campaign/tabs/Flights.vue'

export default [
  {
    path: 'social-products',
    name: 'social-products',
    component: SocialProductsIndex,
    props: (route) => ({ querySearch: route.query.search }),
    redirect: { name: 'social-boost' },
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, hasPublisher],
    },
    children: [
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'social-boost',
        name: 'social-boost',
        component: SocialBoostIndex,
        redirect: { name: 'all' },
        meta: {
          layout: 'app-layout',
          middleware: [auth, checkAppLimits, hasPublisher],
        },
        children: [
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'all',
            name: 'all',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'all',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: null,
              breadcrumbs: false,
            },
          },
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'new',
            name: 'campaigns-new',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'new',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: 0,
              breadcrumbs: false,
            },
          },
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'in-review',
            name: 'campaigns-in-review',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'in-review',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: 2,
              breadcrumbs: false,
            },
          },
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'in-progress',
            name: 'campaigns-in-progress',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'in-progress',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: 4,
              breadcrumbs: false,
            },
          },
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'ready-to-launch',
            name: 'campaigns-ready-to-launch',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'ready-to-launch',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: 5,
              breadcrumbs: false,
            },
          },
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'active',
            name: 'campaigns-campaign-active',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'active',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: 6,
              breadcrumbs: false,
            },
          },
          {
            props: (route) => ({ querySearch: route.query.search }),
            path: 'completed',
            name: 'social-boost-completed',
            component: SocialBoostList,
            meta: {
              layout: 'app-layout',
              tab: 'completed',
              middleware: [auth, checkAppLimits, hasPublisher],
              campaign_state: 7,
              breadcrumbs: false,
            },
          },
        ],
      },
      {
        path: 'social-boost/new/:type',
        name: 'social-boost-create',
        component: CreateCampaign,
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
      },
      {
        path: 'social-boost/edit/:id/:type',
        name: 'social-boost-edit',
        component: EditCampaign,
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
      },
      {
        path: 'social-boost/campaign/:id(\\d+)/flight/:flight_id(\\d+)',
        name: 'campaign-flight-view',
        component: ViewCampaignFlight,
        redirect: { name: 'campaign-flight-assets' },
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
        children: [
          {
            path: 'assets',
            name: 'campaign-flight-assets',
            component: AssetsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'creatives',
            name: 'campaign-flight-creatives',
            component: CreativesTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'screenshots',
            name: 'campaign-flight-screenshots',
            component: ScreenshotsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'notes',
            name: 'campaign-flight-notes',
            component: NotesTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'analytics',
            name: 'campaign-flight-analytics',
            component: AnalyticsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'reports',
            name: 'campaign-flight-reports',
            component: ReportsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'activity',
            name: 'campaign-flight-activity',
            component: ActivityTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
        ],
      },
      {
        path: 'social-boost/campaign/:id(\\d+)/flight/:flight_id(\\d+)/view-flight',
        name: 'flight-view',
        component: ViewFlight,
        redirect: { name: 'view-flight-assets' },
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
        children: [
          {
            path: 'assets',
            name: 'view-flight-assets',
            component: AssetsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
              section: 'view-flight',
            },
          },
          {
            path: 'creatives',
            name: 'view-flight-creatives',
            component: CreativesTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'screenshots',
            name: 'view-flight-screenshots',
            component: ScreenshotsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'notes',
            name: 'view-flight-notes',
            component: NotesTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'analytics',
            name: 'view-flight-analytics',
            component: AnalyticsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
        ],
      },
      //complex
      {
        path: 'social-boost/campaign/:id(\\d+)/new-flight',
        name: 'social-boost-add-flight',
        component: CreateFlight,
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
      },
      {
        path: 'social-boost/campaign/:id(\\d+)/flight/:flight_id(\\d+)/edit-flight',
        name: 'social-boost-edit-flight',
        component: EditFlight,
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
      },
      {
        path: 'social-boost/campaign/:id(\\d+)/flight/:flight_id(\\d+)/add-assets',
        name: 'social-boost-add-assets',
        component: CreateAssets,
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
      },
      {
        path: 'social-boost/campaign/:id(\\d+)/flight/:flight_id(\\d+)/asset/:asset_id(\\d+)/edit-asset',
        name: 'social-boost-edit-asset',
        component: EditAsset,
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher, checkAccessActionSB],
          breadcrumbs: false,
        },
      },
      {
        path: 'social-boost/campaign/:id(\\d+)',
        name: 'view-campaign',
        component: ViewCampaign,
        redirect: { name: 'view-campaign-flights' },
        meta: {
          layout: 'app-layout',
          middleware: [auth, hasPublisher],
          breadcrumbs: false,
        },
        children: [
          {
            path: 'flights',
            name: 'view-campaign-flights',
            component: FlightsTab,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'analytics',
            name: 'view-campaign-analytics',
            component: AnalyticsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'reports',
            name: 'view-campaign-reports',
            component: ReportsTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
          {
            path: 'activity',
            name: 'view-campaign-activity',
            component: ActivityTabs,
            meta: {
              layout: 'app-layout',
              middleware: [auth, hasPublisher],
              breadcrumbs: false,
            },
          },
        ],
      },
    ],
  },
]
